<template>
    <div class="page">
        <div class="left">
            <div class="box">
                <template v-if="!success">
                    <div class="login-entry">
                        <span>已经有账号？</span>
                        <span class="tips" @click="onSwitchLogin">去登录</span>
                    </div>
                    <div class="title">欢迎来到梦饷云</div>
                    <div class="form">
                        <div class="form-item">
                            <div class="label">
                                <div>企业简称</div>
                                <div class="error">
                                    {{ errMsg.companyName }}
                                </div>
                            </div>
                            <div class="name-tips">
                                该简称将用于对外邀请店主时展示且暂不支持修改，请谨慎填写
                            </div>
                            <div class="input">
                                <el-input
                                    size="large"
                                    :class="{ error: errMsg.companyName }"
                                    @focus="onClearErr('companyName')"
                                    v-model="form.companyName"
                                    placeholder="请输入企业名称"
                                    :maxLength="32"
                                ></el-input>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="label">
                                <div>手机号码</div>
                                <div class="error">{{ errMsg.phone }}</div>
                            </div>
                            <div class="input">
                                <el-input
                                    size="large"
                                    placeholder="请输入11位手机号码"
                                    class="input-with-select"
                                    :class="{ error: errMsg.phone }"
                                    @focus="onClearErr('phone')"
                                    v-model="form.phone"
                                    :maxLength="11"
                                >
                                </el-input>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="label">
                                <div>手机验证码</div>
                                <div class="error">
                                    {{ errMsg.authCode }}
                                </div>
                            </div>
                            <div class="input">
                                <el-input
                                    size="large"
                                    :class="{ error: errMsg.authCode }"
                                    @focus="onClearErr('authCode')"
                                    v-model="form.authCode"
                                    placeholder="请输入您的验证码"
                                    :maxLength="6"
                                ></el-input>
                                <div class="btn" @click="onGetCode">
                                    {{
                                        remainTime
                                            ? `${remainTime}S`
                                            : '获取验证码'
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="label">
                                <div>设置密码</div>
                                <div class="error">
                                    {{ errMsg.password }}
                                </div>
                            </div>
                            <div class="input">
                                <el-input
                                    size="large"
                                    type="password"
                                    :class="{ error: errMsg.password }"
                                    @focus="onClearErr('password')"
                                    v-model="form.password"
                                    placeholder="6-16位密码，区分大小写"
                                    :maxLength="16"
                                ></el-input>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="label">
                                <div>确认密码</div>
                            </div>
                            <div class="input">
                                <el-input
                                    size="large"
                                    type="password"
                                    @focus="onClearErr('password')"
                                    v-model="form.password2"
                                    placeholder="6-16位密码，区分大小写"
                                    :maxLength="16"
                                ></el-input>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="label">
                                <div>邀请码</div>
                                <div class="error">
                                    {{ errMsg.inviteCode }}
                                </div>
                            </div>
                            <div class="input">
                                <el-input
                                    size="large"
                                    v-model="form.inviteCode"
                                    placeholder="请输入邀请码"
                                ></el-input>
                            </div>
                        </div>
                        <el-button
                            class="footer"
                            @click="onRegister"
                            :loading="isLoading"
                            >注册</el-button
                        >
                        <div class="form-item agreement-box">
                            <div class="label">
                                <div class="error">
                                    {{ errMsg.confirmProtocol }}
                                </div>
                            </div>
                            <el-checkbox v-model="form.confirmProtocol" />
                            已阅读并同意
                            <a
                                class="agreement-link"
                                @click="handlePushAgreement"
                                >《梦饷云平台服务协议》</a
                            >
                        </div>
                    </div>
                </template>
                <template v-else>
                    <RegisterSuccess />
                </template>
                <!-- </div> -->
            </div>
        </div>
        <div class="right">
            <img
                src="http://akc-file-upload.oss-cn-shanghai.aliyuncs.com/saas/7a20923747a62d92150451f70edb2c8ecb542a46_1617962412310_9.png"
                alt=""
                class="bg"
            />
            <div class="copyright">
                <div>©2017-2019上海众旦信息科技有限公司 |</div>
                <div>沪公网安备31011502007771号| 沪ICP备17055106号</div>
            </div>
        </div>
        <!-- 验证码 -->
        <graph-code
            :visible.sync="dialogVisible"
            @onOk="onOk"
            @onClose="onHideDialog"
            ref="graphCode"
            :phone="form.phone"
            type="register"
        />
        <!-- 选择租户 -->
        <version-select v-if="isShouldSelectTenant" :initData="initData" />
    </div>
</template>
<script>
import { validatePhone } from '@/utils/validate';
import RegisterSuccess from './components/Success';
import GraphCode from '@/components/Graph-Code';
import { ApiRegister } from '@/common/api';

export default {
    name: 'Phone',
    components: {
        RegisterSuccess,
        GraphCode
    },
    data() {
        return {
            isLoading: false, // 是否在提交中
            success: false,
            dialogVisible: false,
            isShouldSelectTenant: false,
            initData: undefined, // 选择租户状态时的数据
            form: {
                companyName: '',
                phone: '',
                authCode: '',
                password: '',
                password2: '',
                inviteCode: '',
                confirmProtocol: false // 是否勾选协议
            },
            errMsg: {
                companyName: '',
                phone: '',
                authCode: '',
                password: '',
                inviteCode: ''
            },
            remainTime: 0
        };
    },
    methods: {
        onSwitchLogin() {
            this.$router.push({ path: '/login' });
        },
        // 清除错误信息
        onClearErr(type) {
            this.errMsg = {
                ...this.errMsg,
                [type]: ''
            };
        },
        // 获取验证码
        onGetCode() {
            if (!this.form.phone || this.form.phone.length !== 11) {
                this.errMsg = {
                    ...this.errMsg,
                    phone: validatePhone(this.form.phone)
                };
                return;
            }
            if (this.remainTime > 0) return;
            this.dialogVisible = true;
        },
        onOk() {
            // 清空输入的值
            this.$refs.graphCode.onClear();
            let count = 59;
            this.remainTime = count--;
            this.timer = setInterval(() => {
                if (count <= 0) clearInterval(this.timer);
                this.remainTime = count--;
            }, 1000);
        },
        onHideDialog() {
            // 清空输入的值
            this.$refs.graphCode.onClear();
        },
        // 提交
        onRegister() {
            const {
                companyName,
                phone,
                authCode,
                password,
                password2,
                inviteCode,
                confirmProtocol
            } = this.form;
            const phoneReg = validatePhone(phone);
            this.errMsg = {
                companyName: !companyName ? '请输入企业名称' : '',
                phone: phoneReg,
                authCode: !authCode ? '请输入验证码' : '',
                password: !password
                    ? '请输入密码'
                    : password.length < 6
                    ? '密码长度至少为6位'
                    : password2 !== password
                    ? '两次输入密码不一致'
                    : '',
                inviteCode: !inviteCode ? '请输入邀请码' : '',
                confirmProtocol: !confirmProtocol ? '请阅读并勾选协议' : ''
            };
            if (
                this.errMsg.companyName ||
                this.errMsg.phone ||
                this.errMsg.authCode ||
                this.errMsg.password ||
                this.errMsg.inviteCode
            ) {
                return;
            }

            if (this.errMsg.confirmProtocol) {
                this.$message.info({
                    message: '请阅读并勾选协议',
                    duration: 2000
                });
                return;
            }
            this.onSubmit();
        },
        // 注册
        onSubmit() {
            if (this.isLoading) return;
            this.isLoading = true;
            const {
                companyName,
                phone,
                authCode,
                password,
                inviteCode,
                confirmProtocol
            } = this.form;
            const params = {
                companyName,
                phone,
                authCode,
                pwd: password,
                confirmProtocol
            };
            if (inviteCode) {
                params.inviteCode = inviteCode;
            }
            ApiRegister(params)
                .then(() => {
                    this.isLoading = false;
                    this.$message({
                        message: '注册成功',
                        duration: 1000,
                        type: 'success',
                        onClose: () => {
                            // 跳转到登录页
                            this.$router.replace({
                                path: '/login'
                            });
                        }
                    });
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        handlePushAgreement() {
            this.$router.push({
                path: '/agreement'
            });
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
$baseColor: #f56c6c;
.pop-box {
    width: 272px;
    height: 126px;
    border-radius: 4px;
    padding: 16px;
    .desc {
        font-size: 14px;
        font-weight: 400;
        color: $baseColor;
        line-height: 22px;
        text-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    }
    .process {
        margin-top: 6px;
        width: 226px;
        height: 6px;
        background: #f5f5f5;
        border-radius: 100px;
        position: relative;
        &-inner {
            position: absolute;
            left: 0;
            top: 0;
            height: 6px;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
            border-radius: 100px;
        }
    }
    .tips {
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
        text-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    }
}
.page {
    min-width: 1100px;
    height: 100%;
    min-height: 768px;
    display: flex;
    .name-tips {
        font-size: 12px;
        font-weight: 400;
        color: #f56c6c;
        line-height: 12px;
        margin: 6px 0;
    }
    .left {
        flex: 1;
        padding: 50px 0;
        .box {
            margin: 0 auto;
            width: 336px;
        }
        .login-entry {
            margin-bottom: 30px;
            text-align: right;
            font-size: 14px;
            font-weight: 400;
            color: #5a5f66;
            line-height: 14px;
            .tips {
                cursor: pointer;
                height: 14px;
                font-size: 14px;
                font-weight: 400;
                color: #0772eb;
                line-height: 14px;
            }
        }
        .title {
            font-size: 34px;
            font-weight: 600;
            color: #242424;
            line-height: 34px;
            margin-bottom: 40px;
        }
        .form {
            ::v-deep {
                .el-select .el-input {
                    min-width: 90px;
                }
                .el-select .el-input__inner {
                    border-color: transparent !important;
                }
                .input-with-select .el-input-group__prepend {
                    background-color: #fff;
                }
            }
            .form-item {
                margin-bottom: 18px;
                text-align: left;
            }
            .agreement-box {
                .agreement-link {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #0772eb;
                    line-height: 18px;
                    cursor: pointer;
                }
            }
            .error {
                border-color: $baseColor;
            }
            .label {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                font-size: 14px;
                font-weight: 400;
                color: #2d2e33;
                line-height: 14px;
                position: relative;
                .error {
                    margin-left: 10px;
                    font-size: 12px;
                    font-weight: 400;
                    color: $baseColor;
                    line-height: 12px;
                }
                .tips {
                    position: absolute;
                }
            }
            .input {
                position: relative;
                .btn {
                    cursor: pointer;
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    margin-top: -6px;
                    height: 14px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #0772eb;
                    line-height: 14px;
                }
            }
            .footer {
                margin-bottom: 12px;
                cursor: pointer;
                margin-top: 30px;
                background: $baseColor;
                width: 335px;
                height: 48px;
                text-align: center;
                color: #fff;
                border-radius: 4px;
                border: 0;
            }
        }
    }
    .right {
        height: 100%;
        .bg {
            height: 100%;
        }
        position: relative;
        .copyright {
            text-align: center;
            width: 280px;
            height: 32px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 16px;
            position: absolute;
            bottom: 18px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>
